<template lang="html">
    <div>
        <span class="px-2 py-0 radius-normal fs-smaller bold" v-tooltip="logMessageToShow" :class="resultClass">{{foundResult.label}}</span>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
export default {
    props: {
        arguments:{
            required: true
        }
    },
    computed: {
        ...mapGetters([
            'getTaskExecutionResult'
        ]),
        foundResult: function() {
            let output = this.getTaskExecutionResult.find(storedResult => {
                return storedResult.id == this.arguments.taskExecutionResult
            })

            if(output){
                return output
            } else {
                return null
            }
        },
        resultClass: function () {
            return [
                'bg-' + this.foundResult.color1,
                this.foundResult.color2
            ];
        },
        logMessageToShow :function () {
            if(this.arguments.scheduleTaskInstanceLogList && this.arguments.scheduleTaskInstanceLogList.length > 0){
                return this.arguments.scheduleTaskInstanceLogList[this.arguments.scheduleTaskInstanceLogList.length - 1].summary
            } else {
                return null
            }
        }
    }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// taskResultLabel.vue?216dc4df